import * as classnames from 'classnames'
import * as React from 'react'
import * as classNames from './reviewer-summary.css'

export interface IProps {
  className?: string
  npi: string
  isApproved: boolean
}

export class ReviewerSummary extends React.PureComponent<IProps, {}> {
  public render() {
    // TODO I18N
    return (
      <div className={this.props.className}>
        {this.props.isApproved
          ? <p className={classnames(classNames.treatmentActive, classNames.treatmentStatus)}>
              physician active & approved
            </p>
          : <p className={classnames(classNames.treatmentInactive, classNames.treatmentStatus)}>
              physician not approved
            </p>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/reviewers/reviewer-summary.tsx